import { useState, useEffect } from 'react';
import './Header.css';
import { Link, useNavigate } from 'react-router-dom';
import { FaPhone, FaUser, FaBars, FaTimes } from 'react-icons/fa';
import { isLoggedIn, getUser, logout } from '../utils/auth';

function Header() {
  const navigate = useNavigate();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [user, setUser] = useState(getUser());
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  /* ─────────── Keep in sync with localStorage ─────────── */
  useEffect(() => {
    const syncAuth = () => setUser(getUser());
    window.addEventListener("storage", syncAuth);
    return () => window.removeEventListener("storage", syncAuth);
  }, []);

  const loggedIn = !!user;

  const toggleMobileNav = () => setMobileNavOpen((prev) => !prev);
  const handleDropdownToggle = (name) =>
    setActiveDropdown((prev) => (prev === name ? null : name));
  const closeMobileNav = () => {
    setMobileNavOpen(false);
    setActiveDropdown(null);
    setUserMenuOpen(false);
  };

  const handleLogout = () => {
    logout(); // clears token & user
    setUser(null);
    setUserMenuOpen(false);
    closeMobileNav();
    navigate("/login");
  };

  const phoneLinks = (
    <>
      <a href="tel:+917905513982"><FaPhone /> +91 7905513982</a>
      <a href="tel:+918840155356"><FaPhone /> +91 8840155356</a>
    </>
  );

  return (
    <header className="main-header">
      {/* ── Top Bar ── */}
      <div className="top-bar">
        <img
          src="/Jyotish-Karmaa-logo.png"
          alt="Jyotish Karmaa Logo"
          className="logo"
        />

        <div className="contact-login">
          <span className="phone-desktop">{phoneLinks}</span>

          {!loggedIn ? (
            <>
              <Link to="/login" onClick={closeMobileNav}>
                <span className="mobile-login"> Log in</span>
              </Link>
              <Link to="/signup" onClick={closeMobileNav} className="hide-mobile">
                <span>Sign up</span>
              </Link>
            </>
          ) : (
            <div
              className="user-dropdown"
              onClick={() => setUserMenuOpen(prev => !prev)}
            >
              <span className="user-name">
                <FaUser /> {user?.name || "Profile"} ▾
              </span>
              {userMenuOpen && (
                <div className="user-menu">
                  <Link to="/profile" onClick={closeMobileNav}>Profile</Link>
                  <button onClick={handleLogout} className="logout-btn">
                    Logout
                  </button>
                </div>
              )}
            </div>

            
          )}
        </div>

        

        <button
          className="hamburger"
          onClick={toggleMobileNav}
          aria-label="Toggle navigation"
        >
          {mobileNavOpen ? <FaTimes /> : <FaBars />}
        </button>

        <div className="mobile-main-services">
  {/* Services Dropdown with toggle */}
  <div className={`mobile-dropdown ${activeDropdown === "services-mobile" ? "open" : ""}`}>
    <span
      className="mobile-btn"
      onClick={() =>
        setActiveDropdown(prev =>
          prev === "services-mobile" ? null : "services-mobile"
        )
      }
    >
      Services ▾
    </span>

    <div className="mobile-dropdown-content">
      <Link to="/services/Classes" onClick={closeMobileNav}>Astrology Classes</Link>
      <Link to="/services/astro-vastu" onClick={closeMobileNav}>Astro Vastu</Link>
      <Link to="/services/astrology" onClick={closeMobileNav}>Astrology</Link>
      <Link to="/services/litigation" onClick={closeMobileNav}>Litigation</Link>
      <Link to="/services/matchs-making" onClick={closeMobileNav}>Matchmaking</Link>
      <Link to="/services/muhurta" onClick={closeMobileNav}>Muhurta</Link>
    </div>
  </div>

  {/* About Us button */}
  <Link to="/about" className="mobile-btn" onClick={closeMobileNav}>
    About Us
  </Link>
</div>


      </div>

      {/* ── Navigation Bar ── */}
      <nav className={`nav-bar ${mobileNavOpen ? 'open' : ''}`}>
        <Link to="/" onClick={closeMobileNav}>Home</Link>
        <Link to="/about" onClick={closeMobileNav}>About</Link>
        <Link to="/courses" onClick={closeMobileNav}>Courses</Link>
        <Link to="/gauseva" onClick={closeMobileNav}>Gauseva</Link>

        <div className={`dropdown ${activeDropdown === 'services' ? 'active' : ''}`}>
          <span onClick={() => handleDropdownToggle('services')}>Services ▾</span>
          <div className="dropdown-content">
            <Link to="/services/Classes">Astrology Classes</Link>
            <Link to="/services/astro-vastu">Astro Vastu</Link>
            <Link to="/services/astrology">Astrology</Link>
            <Link to="/services/litigation">Litigation</Link>
            <Link to="/services/matchs-making">Matchmaking</Link>
            <Link to="/services/muhurta">Muhurta</Link>
            <Link to="/services/wealth-astrology">Wealth Astrology</Link>
            <Link to="/services/career-prediction">Career Prediction</Link>
            <Link to="/services/health-astrology">Health Astrology</Link>
            <Link to="/services/love-astrology">Love Astrology</Link>
          </div>
        </div>

        <Link to="/divinestore" onClick={closeMobileNav}>Divine Store</Link>
        <Link to="/blog" onClick={closeMobileNav}>Blog</Link>
        <Link to="/contact" onClick={closeMobileNav}>Contact</Link>
      </nav>
    </header>
  );
}

export default Header;
